import { Box, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';

const TAB_ICON_SIZE = 24;

type TabSectionHeaderProps = {
  icon: React.FunctionComponent;
  title: string;
  trailing?: ReactNode;
  marginBottom?: number | string;
};

export const TabSectionHeader = ({
  icon: Icon,
  title,
  trailing,
  marginBottom = '20px',
}: TabSectionHeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        marginBottom,
        svg: {
          width: TAB_ICON_SIZE,
          height: TAB_ICON_SIZE,
          flexShrink: 0,
          display: 'block',
        },
        'svg path': {
          stroke: theme.palette.getContrastText(theme.palette.background.default),
        },
      }}>
      <Icon />
      <Typography fontSize="18px" fontWeight={600} sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      {trailing}
    </Box>
  );
};
